module.exports = __webpack_public_path__ + "img/logo-ubcare.d72e3b3b.svg";